function cov_seqla0kc4() {
  var path = "/app/src/utils/fetch-with-retry.ts";
  var hash = "a038526f9c209ea5955da385f01455dae85cb0d5";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/utils/fetch-with-retry.ts",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 20
        },
        end: {
          line: 1,
          column: 50
        }
      },
      "1": {
        start: {
          line: 2,
          column: 16
        },
        end: {
          line: 2,
          column: 17
        }
      },
      "2": {
        start: {
          line: 3,
          column: 16
        },
        end: {
          line: 3,
          column: 19
        }
      },
      "3": {
        start: {
          line: 12,
          column: 30
        },
        end: {
          line: 52,
          column: 1
        }
      },
      "4": {
        start: {
          line: 18,
          column: 2
        },
        end: {
          line: 51,
          column: 3
        }
      },
      "5": {
        start: {
          line: 19,
          column: 21
        },
        end: {
          line: 19,
          column: 51
        }
      },
      "6": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 37,
          column: 5
        }
      },
      "7": {
        start: {
          line: 22,
          column: 6
        },
        end: {
          line: 35,
          column: 7
        }
      },
      "8": {
        start: {
          line: 23,
          column: 8
        },
        end: {
          line: 27,
          column: 11
        }
      },
      "9": {
        start: {
          line: 24,
          column: 10
        },
        end: {
          line: 26,
          column: 22
        }
      },
      "10": {
        start: {
          line: 25,
          column: 12
        },
        end: {
          line: 25,
          column: 26
        }
      },
      "11": {
        start: {
          line: 29,
          column: 8
        },
        end: {
          line: 34,
          column: 11
        }
      },
      "12": {
        start: {
          line: 36,
          column: 6
        },
        end: {
          line: 36,
          column: 64
        }
      },
      "13": {
        start: {
          line: 39,
          column: 4
        },
        end: {
          line: 42,
          column: 5
        }
      },
      "14": {
        start: {
          line: 41,
          column: 6
        },
        end: {
          line: 41,
          column: 18
        }
      },
      "15": {
        start: {
          line: 44,
          column: 17
        },
        end: {
          line: 44,
          column: 38
        }
      },
      "16": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 46,
          column: 16
        }
      },
      "17": {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 49,
          column: 51
        }
      },
      "18": {
        start: {
          line: 50,
          column: 4
        },
        end: {
          line: 50,
          column: 16
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 12,
            column: 30
          },
          end: {
            line: 12,
            column: 31
          }
        },
        loc: {
          start: {
            line: 17,
            column: 33
          },
          end: {
            line: 52,
            column: 1
          }
        },
        line: 17
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 23,
            column: 26
          },
          end: {
            line: 23,
            column: 27
          }
        },
        loc: {
          start: {
            line: 23,
            column: 39
          },
          end: {
            line: 27,
            column: 9
          }
        },
        line: 23
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 24,
            column: 21
          },
          end: {
            line: 24,
            column: 22
          }
        },
        loc: {
          start: {
            line: 24,
            column: 27
          },
          end: {
            line: 26,
            column: 11
          }
        },
        line: 24
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 15,
            column: 2
          },
          end: {
            line: 15,
            column: 19
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 15,
            column: 12
          },
          end: {
            line: 15,
            column: 19
          }
        }],
        line: 15
      },
      "1": {
        loc: {
          start: {
            line: 16,
            column: 2
          },
          end: {
            line: 16,
            column: 19
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 16,
            column: 12
          },
          end: {
            line: 16,
            column: 19
          }
        }],
        line: 16
      },
      "2": {
        loc: {
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 37,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 37,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 21
      },
      "3": {
        loc: {
          start: {
            line: 22,
            column: 6
          },
          end: {
            line: 35,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 22,
            column: 6
          },
          end: {
            line: 35,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 22
      },
      "4": {
        loc: {
          start: {
            line: 22,
            column: 10
          },
          end: {
            line: 22,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 22,
            column: 10
          },
          end: {
            line: 22,
            column: 21
          }
        }, {
          start: {
            line: 22,
            column: 25
          },
          end: {
            line: 22,
            column: 62
          }
        }],
        line: 22
      },
      "5": {
        loc: {
          start: {
            line: 39,
            column: 4
          },
          end: {
            line: 42,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 39,
            column: 4
          },
          end: {
            line: 42,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 39
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "a038526f9c209ea5955da385f01455dae85cb0d5"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_seqla0kc4 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_seqla0kc4();
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var ERROR_CODES = (cov_seqla0kc4().s[0]++, [409, 429, 500, 502, 503, 504]);
var RETRIES = (cov_seqla0kc4().s[1]++, 3);
var BACKOFF = (cov_seqla0kc4().s[2]++, 300);
cov_seqla0kc4().s[3]++;
var _fetchWithRetry = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref) {
    var url, options, _ref$retries, retries, _ref$backoff, backoff, response, data, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          url = _ref.url, options = _ref.options, _ref$retries = _ref.retries, retries = _ref$retries === void 0 ? (cov_seqla0kc4().b[0][0]++, RETRIES) : _ref$retries, _ref$backoff = _ref.backoff, backoff = _ref$backoff === void 0 ? (cov_seqla0kc4().b[1][0]++, BACKOFF) : _ref$backoff;
          cov_seqla0kc4().f[0]++;
          cov_seqla0kc4().s[4]++;
          _context.p = 1;
          cov_seqla0kc4().s[5]++;
          _context.n = 2;
          return fetch("".concat(url), options);
        case 2:
          response = _context.v;
          cov_seqla0kc4().s[6]++;
          if (response.ok) {
            _context.n = 7;
            break;
          }
          cov_seqla0kc4().b[2][0]++;
          cov_seqla0kc4().s[7]++;
          if (!((cov_seqla0kc4().b[4][0]++, retries > 0) && (cov_seqla0kc4().b[4][1]++, ERROR_CODES.includes(response.status)))) {
            _context.n = 5;
            break;
          }
          cov_seqla0kc4().b[3][0]++;
          cov_seqla0kc4().s[8]++;
          _context.n = 3;
          return new Promise(function (resolve) {
            cov_seqla0kc4().f[1]++;
            cov_seqla0kc4().s[9]++;
            setTimeout(function () {
              cov_seqla0kc4().f[2]++;
              cov_seqla0kc4().s[10]++;
              resolve(null);
            }, backoff);
          });
        case 3:
          cov_seqla0kc4().s[11]++;
          _context.n = 4;
          return _fetchWithRetry({
            url: url,
            options: options,
            retries: retries - 1,
            backoff: backoff * 2
          });
        case 4:
          return _context.a(2, _context.v);
        case 5:
          cov_seqla0kc4().b[3][1]++;
        case 6:
          cov_seqla0kc4().s[12]++;
          throw new Error("HTTP error! Status: ".concat(response.status));
        case 7:
          cov_seqla0kc4().b[2][1]++;
        case 8:
          cov_seqla0kc4().s[13]++;
          if (!(response.status === 204)) {
            _context.n = 9;
            break;
          }
          cov_seqla0kc4().b[5][0]++;
          cov_seqla0kc4().s[14]++;
          return _context.a(2, null);
        case 9:
          cov_seqla0kc4().b[5][1]++;
        case 10:
          cov_seqla0kc4().s[15]++;
          _context.n = 11;
          return response.json();
        case 11:
          data = _context.v;
          cov_seqla0kc4().s[16]++;
          return _context.a(2, data);
        case 12:
          _context.p = 12;
          _t = _context.v;
          cov_seqla0kc4().s[17]++;
          // eslint-disable-next-line no-console
          console.error("Request failed: ".concat(url), _t);
          cov_seqla0kc4().s[18]++;
          throw _t;
        case 13:
          return _context.a(2);
      }
    }, _callee, null, [[1, 12]]);
  }));
  return function fetchWithRetry(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export { _fetchWithRetry as fetchWithRetry };